<script>
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import { toast } from "@zerodevx/svelte-toast";
import * as m from '@app/paraglide/messages.js';
const copyEvents = function() {
    if (eventGroupState[projectState.selected].selected.length > 0) {
        let textToCopy, range = window?.quillEditor?.getSelection();
        if (range && range.length !== 0 && eventGroupState[projectState.selected].selected.length === 1) {
            textToCopy = window.quillEditor.getText(range.index, range.length);
        } else {
            let eventsToCopy = [];
            eventGroupState[projectState.selected].selected.sort((eventA, eventB) =>{
                return eventA - eventB;
            }).forEach(eventIndex => {
                eventsToCopy.push(eventGroupState[projectState.selected].events[eventIndex]);
            });

            textToCopy = JSON.stringify(eventsToCopy);
        }

        navigator.clipboard.writeText(textToCopy);
        toast.push(m.copy_toast_success(), {
            classes: ["toast-success"],
        });
    }
}
</script>
<li class="nav-item" title={m.copy_title()}>
    <a 
        class="nav-link" 
        href="#!/" 
        id="copy-event-btn"
        role="button"
        aria-label={m.copy_aria_label()}
        aria-disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0}
        class:disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0}
        onclick={copyEvents}
    ><i class="bi bi-clipboard-plus"></i></a>
</li>